export class CardActionPayload {
  /** @type {String|null} */
  action;

  /** @type {Object} */
  deal;

  /** @type {Object} */
  interlocutor;

  /** @type {String|null} */
  fromColumn;

  /** @type {Number|null} */
  fromColumnIndex;

  /** @type {String|null} */
  toColumn;

  /** @type {CardActionPayload|null} */
  next;
}
